export default class Constants {
    static API_URL = process.env.REACT_APP_API_URL ;
}
